import { ReactNode } from 'react';
import { create } from 'zustand'

interface StoreInterface {
  showModal: boolean,
  modalHeight?: number,
  modalWidth?: number,
  modalHeader?: ReactNode,
  modalContent?: ReactNode,
  shouldCloseOnOverlayClick: boolean
}

const BlankState: StoreInterface = {
  showModal: false,
  modalHeight: undefined,
  modalWidth: undefined,
  modalContent: undefined,
  shouldCloseOnOverlayClick: true
};

export default class ModalModel {
  static useState = create<StoreInterface>(set => ({ ...BlankState }))
  static setState = ModalModel.useState.setState;
  static get state() { return ModalModel.useState.getState(); }
  static reset() { ModalModel.setState({ ...BlankState }); }

  static showModalWithContent(
    header?: ReactNode,
    content?: ReactNode,
    modalHeight?: number,
    modalWidth?: number,
    shouldCloseOnOverlayClick: boolean = true
  ) {
    ModalModel.setState({
      showModal: true,
      modalHeight: modalHeight,
      modalWidth: modalWidth,
      modalHeader: header,
      modalContent: content,
      shouldCloseOnOverlayClick: shouldCloseOnOverlayClick
    })
  }
  static hideModal() {
    ModalModel.setState({
      showModal: false,
    })
  }
}